<cass-core-toolbar></cass-core-toolbar>
<mat-horizontal-stepper linear #editOrderStepper [selectedIndex]="currentStep">

	<mat-step [completed]="isSelectPlacementCategoryCompleted">
		<ng-template matStepLabel>{{ "ORDER.STEPPER.CATEGORY" | translate }}<span class="stepper-label-small">{{orderVM.adVM.placementCategory?.label}}</span></ng-template>
		<div class="step-content-container">
			<mat-card class="branding--title-card">
				<mat-card-content>
					<h1>{{ "ORDER.SELECT_CATEGORY" | translate }}</h1>
				</mat-card-content>
			</mat-card>
			<cass-order-select-placement-category [placementCategories]="staticDataPlacementCategories" [selectedPlacementCategory]="orderVM.adVM.placementCategory" (placementCategoryChanged)="uiSelectPlacementCategory($event)">
			</cass-order-select-placement-category>
		</div>
	</mat-step>

	<mat-step [completed]="isSelectPlacementCompleted">
		<ng-template matStepLabel>{{ "ORDER.STEPPER.PLACEMENT" | translate }}<span class="stepper-label-small">{{orderVM.adVM.placement?.label}}</span></ng-template>
		<div class="step-content-container">
			<div class="top-actions">
				<button mat-button color='accent' matStepperPrevious>
					<mat-icon>chevron_left</mat-icon>
					{{ "ORDER.NAVIGATION_BACK" | translate }}
				</button>
				<div class="spacer"></div>
			</div>
			<mat-card class="branding--title-card">
				<mat-card-content>
					<h1>{{ "ORDER.SELECT_PLACEMENT" | translate }}</h1>
				</mat-card-content>
			</mat-card>
			<cass-order-select-placement [placements]="staticDataPlacements" [selectedPlacement]="orderVM.adVM.placement" (placementChanged)="uiSelectPlacement($event)">
			</cass-order-select-placement>
		</div>
	</mat-step>

	<mat-step [completed]="isSelectPackageCompleted">
		<ng-template matStepLabel>{{ "ORDER.STEPPER.PACKAGE" | translate }}<span class="stepper-label-small">{{orderVM.adVM.package?.label}}</span></ng-template>
		<div class="step-content-container">
			<div class="top-actions">
				<button mat-button color='accent' matStepperPrevious>
					<mat-icon>chevron_left</mat-icon>
					{{ "ORDER.NAVIGATION_BACK" | translate }}
				</button>
				<div class="spacer"></div>
			</div>
			<mat-card class="branding--title-card">
				<mat-card-content>
					<h1>{{ "ORDER.SELECT_PACKAGE" | translate }}</h1>
				</mat-card-content>
			</mat-card>
			<cass-order-select-package [packages]="staticDataPackages" [selectedPackage]="orderVM.adVM.package" (packageChanged)="uiSelectPackage($event)">
			</cass-order-select-package>
		</div>
	</mat-step>

	<mat-step [completed]="isAdDetailsSectionCompleted && adDetailsConfirmed">
		<ng-template matStepLabel>{{ "ORDER.STEPPER.DETAILS" | translate }}</ng-template>
		<div class="step-content-container">
			<div class="top-actions">
				<button mat-button color='accent' matStepperPrevious>
					<mat-icon>chevron_left</mat-icon>
					{{ "ORDER.NAVIGATION_BACK" | translate }}
				</button>
			</div>
			<div class="spacer"></div>
			<mat-card class="branding--title-card">
				<mat-card-content>
					<h1>{{ "ORDER.BUILD_YOUR_AD_CARD_TITLE" | translate }}</h1>
				</mat-card-content>
			</mat-card>
			<div class="ad-details-container">
				<mat-card class="branding--section-card">
					<mat-card-content>
						<h2>{{ "ORDER.SELECT_STYLE_CARD_TITLE" | translate }}</h2>
						<cass-order-select-style [styles]="staticDataStyles" [selectedStyle]="orderVM.contentVM.style" (styleChanged)="selectStyle($event)">
						</cass-order-select-style>
					</mat-card-content>
				</mat-card>
				<div class='flex-row'>
					<mat-card class="branding--section-card">
						<mat-card-content>
							<h2>{{ "ORDER.ENTER_AD_TEXT_CARD_TITLE" | translate }}</h2>
							<cass-ck-text-editor *ngIf="textEditorType === TextEditorType.CKEDTOR" [initialContent]="orderVM.contentVM.adText" (contentChanged)="ckEditorContentChanged($event)"></cass-ck-text-editor>
							<cass-multi-field-text-editor *ngIf="textEditorType === TextEditorType.MULTIFIELD" [initialContent]="multiFieldInitialContent" [templateElements]="multiFieldStyleElements" [packageId]="orderVM.adVM.package?.id" [placementId]="orderVM.adVM.placement?.id"
														  (multiFieldContentChanged)="multiFieldContentChanged($event)"></cass-multi-field-text-editor>
						</mat-card-content>
					</mat-card>
					<mat-card class="branding--section-card">
						<mat-card-content>
							<h2>{{ "ORDER.PREVIEW_CARD_TITLE" | translate }}</h2>
							<cass-ad-preview [previewDataURL]="orderVM.contentVM.preview"
											 [message]="adPreviewMessage"
											 [isError]="adPreviewError"
											 [isCalculating]="calculatingOverlay$.value">
							</cass-ad-preview>
						</mat-card-content>
					</mat-card>
				</div>
				<div class='flex-row'>
					<mat-card class="branding--section-card">
						<mat-card-content>
							<h2>{{ "ORDER.CHOOSE_DATES_CARD_TITLE" | translate }}</h2>
							<cass-order-select-issues [issueDates]="staticDataIssueDates" [selectedDates]="orderVM.adVM.issueDates" (issuesSelected)="selectIssues($event)"></cass-order-select-issues>
						</mat-card-content>
					</mat-card>
					<mat-card class="branding--section-card">
						<mat-card-content>
							<h2>{{ "ORDER.PRICE_CARD_TITLE" | translate }}</h2>
							<cass-price-breakdown [issueDateCount]="issueDateCount"
												  [currencyCode]="orderVM.adVM.currencyCode"
												  [priceExTax]="orderVM.adVM.priceNetExTax"
												  [priceIncTax]="orderVM.adVM.priceNetIncTax"
												  [tax]="orderVM.adVM.tax"
												  [isCalculating]="calculatingOverlay$.value"
												  [message]="pricingMessage"
												  [isError]="pricingError"
												  [isCustomerNumberApplicable]="orderVM.adVM.placement?.subscriberDiscountEligible"
												  [initialCustomerNumber]="orderVM.subscriberNumber"
												  [discountAppliedMessage]="discountAppliedMessage"
												  [discountFailedMessage]="discountFailedMessage"
												  (customerNumberChanged)="customerNumberChanged($event)">
							</cass-price-breakdown>
						</mat-card-content>
					</mat-card>
				</div>
				<mat-card class='footer branding--action-card button-container'>
					<mat-card-content>
						<button mat-raised-button color='primary' [disabled]="!isAdDetailsSectionCompleted" (click)="confirmAdDetails()">
							{{ "ORDER.CONFIRM_ACTION" | translate }}
						</button>
					</mat-card-content>
				</mat-card>

			</div>
		</div>
	</mat-step>

	<mat-step [completed]="customerDetailsForm.valid && customerDetailsConfirmed">
		<ng-template matStepLabel>{{ "ORDER.STEPPER.CONFIRM" | translate }}</ng-template>
		<div class="step-content-container">
			<div class="top-actions">
				<button mat-button color='accent' matStepperPrevious>
					<mat-icon>chevron_left</mat-icon>
					{{ "ORDER.NAVIGATION_BACK" | translate }}
				</button>
			</div>
			<div class="spacer"></div>
			<mat-card class="branding--title-card">
				<mat-card-content>
					<h1>{{ "ORDER.CONFIRM.CONFIRM_YOUR_AD_CARD_TITLE" | translate }}</h1>
				</mat-card-content>
			</mat-card>
			<div class="confirm-content-container">

				<div class="confirm-content-customer-info-container">
					<mat-card *ngIf="(appConfigService.config$ | async)?.loginEnabled && !(authService?.authStatus$ | async)?.isAuthenticated" class="branding--section-card">
						<mat-card-content>
							<h2>{{ "ORDER.CONFIRM.ACCOUNT_TITLE" | translate}}</h2>
							<!-- <h2>Already registered? &nbsp;&nbsp; <button mat-raised-button color="primary">Login</button></h2> -->
						</mat-card-content>
					</mat-card>
					<form [formGroup]="customerDetailsForm" class="customer-info-form">
						<mat-card class="branding--section-card">
							<mat-card-content>
								<h2 *ngIf="(authService?.authStatus$ | async)?.isAuthenticated">{{ "ORDER.CONFIRM.CONFIRM_CONTACT_DETAILS_TITLE" | translate }}</h2>
								<h2 *ngIf="!(authService?.authStatus$ | async)?.isAuthenticated">{{ "ORDER.CONFIRM.ENTER_CONTACT_DETAILS_TITLE" | translate }}</h2>
								<cass-contact-details [parentForm]="customerDetailsForm" [allowIntrinsicAccountCreation]="true" [initialDetails]="initialContactDetails">
								</cass-contact-details>
							</mat-card-content>
						</mat-card>
						<mat-card *ngIf="safeHtmlTermsAndConditions" class="mat-card-terms-and-conditions branding--section-card">
							<mat-card-content>
								<h2>{{ "ORDER.CONFIRM.TERMS_TITLE" | translate }}</h2>
								<mat-checkbox [formControl]="agreeToTermsAndConditions" color="primary">
									{{ "ORDER.CONFIRM.TERMS_TEXT_1" | translate }}
									<span class="termsAndConditionsLink" (click)="openTermsAndConditionsDialog()">{{ "ORDER.CONFIRM.TERMS_LINK_TEXT" | translate }}</span>
									{{ "ORDER.CONFIRM.TERMS_TEXT_2" | translate }}
								</mat-checkbox>
								<mat-error [cassErrorForFormControl]='agreeToTermsAndConditions'></mat-error>
							</mat-card-content>
						</mat-card>
					</form>
				</div>
				<div class="confirm-content-ad-details-container">
					<mat-card class="mat-card-ad-details branding--section-card">
						<mat-card-content>
							<h2>{{ "ORDER.CONFIRM.AD_DETAILS_HEADING" | translate}}</h2>
							<h3>{{ "ORDER.CONFIRM.PLACEMENT_HEADING" | translate}}</h3>
							<cass-display-placement [placementLabel]="orderVM.adVM.placement?.label"></cass-display-placement>
							<h3>{{ "ORDER.CONFIRM.PUBLICATIONS_HEADING" | translate}}</h3>
							<cass-display-products-list [productNames]="productNames"></cass-display-products-list>
							<h3>{{ "ORDER.CONFIRM.DATES_HEADING" | translate }}</h3>
							<cass-display-dates-list [dates]="orderVM.adVM.issueDates"></cass-display-dates-list>
							<h3>{{ "ORDER.CONFIRM.PREVIEW_HEADING" | translate }}</h3>
							<cass-ad-preview [previewDataURL]="orderVM.contentVM.preview"></cass-ad-preview>
							<h3>{{ "ORDER.CONFIRM.PRICE_HEADING" | translate }}</h3>
							<cass-price-breakdown [issueDateCount]="issueDateCount"
												  [currencyCode]="orderVM.adVM.currencyCode"
												  [priceExTax]="orderVM.adVM.priceNetExTax"
												  [priceIncTax]="orderVM.adVM.priceNetIncTax"
												  [tax]="orderVM.adVM.tax"
												  [isCalculating]="calculatingOverlay$.value"
												  [message]="pricingMessage"
												  [isError]="pricingError"
												  [isCustomerNumberApplicable]="orderVM.adVM.placement?.subscriberDiscountEligible"
												  [initialCustomerNumber]="orderVM.subscriberNumber"
												  [discountAppliedMessage]="discountAppliedMessage"
												  [discountFailedMessage]="discountFailedMessage"
												  (customerNumberChanged)="customerNumberChanged($event)">
							</cass-price-breakdown>
						</mat-card-content>
					</mat-card>
				</div>
			</div>
			<mat-card class="footer branding--action-card button-container">
				<mat-card-content>
					<button mat-raised-button color='primary' [disabled]="!customerDetailsForm.valid" (click)="customerDetailsCompleted()">{{ "ORDER.CONFIRM.PAYMENT_ACTION" | translate }}</button>
				</mat-card-content>
			</mat-card>
		</div>
	</mat-step>

	<mat-step [completed]="false">
		<ng-template matStepLabel>{{ "ORDER.STEPPER.PAYMENT" | translate }}</ng-template>
		<div class="step-content-container">
			<div class="top-actions">
				<button mat-button color='accent' matStepperPrevious>
					<mat-icon>chevron_left</mat-icon>
					{{ "ORDER.NAVIGATION_BACK" | translate }}
				</button>
			</div>
			<div class="spacer"></div>
			<mat-card class="branding--title-card">
				<mat-card-content>
					<h1>{{ "ORDER.PAYMENT.TITLE" | translate }}</h1>
				</mat-card-content>
			</mat-card>
			<mat-card class="mat-card-payment branding--action-card button-container" *ngIf="paytrailLegacyEnabled">
				<mat-card-content>
					<div class='branding--payment--paytrail-logo' alt='Pay using Paytrail'></div>
					<button mat-raised-button color='primary' [disabled]="isProceedToPaymentActivated" (click)="proceedToPayment(PaymentGatewayCode.PAYTRAIL_LEGACY)">{{ "ORDER.PAYMENT.PROCEED_TO_PAYMENT_BUTTON" | translate }}</button>
				</mat-card-content>
			</mat-card>
			<mat-card class="mat-card-payment branding--action-card button-container" *ngIf="paytrail2022Enabled">
				<mat-card-content>
					<div class='branding--payment--paytrail-logo' alt='Pay using Paytrail'></div>
					<button mat-raised-button color='primary' [disabled]="isProceedToPaymentActivated" (click)="proceedToPayment(PaymentGatewayCode.PAYTRAIL_2022)">{{ "ORDER.PAYMENT.PROCEED_TO_PAYMENT_BUTTON" | translate }}</button>
				</mat-card-content>
			</mat-card>
		</div>
	</mat-step>

	<!-- Replace the edit icon with the step number -->
	<ng-template matStepperIcon="edit">
		<span>{{editOrderStepper.selectedIndex + 1}}</span>
	</ng-template>

</mat-horizontal-stepper>
